/**
 * Display a shared wishlist.
 * Custom implementation of this.swat.ui.renderSharedWishlistInContainer
 */
class SharedWishlist extends HTMLElement {
	constructor() {
		super();
		this.swat = undefined;
		this.sharedHKey = undefined;
		this.queryParams = undefined;
		this.settings = undefined;
		this.elements = undefined;
		this.translations = undefined;
		this.currency_symbol = undefined;
	}

	connectedCallback() {
		this.setAttribute("data-state", "loading");
		this.registerSwat();
	}

	registerSwat() {
		if (!window.SwymCallbacks) {
			window.SwymCallbacks = [];
		}

		window.SwymCallbacks.push((swat) => {
			this.swat = swat;
			this.init();
			this.fetchList();
		});
	}

	init() {
		const wishlistElement = document.querySelector(".swymcs-custom-wishlist");
		this.settings = JSON.parse(wishlistElement.dataset.settings);
		this.sectionId = wishlistElement.dataset.sectionid;
		this.currency_symbol = wishlistElement.dataset.currency || "€"; // Use the currency symbol from the dataset or default to Euro

		this.translations = JSON.parse(document.querySelector("#custom-wishlist-translations").textContent || "[]");

		this.elements = {
			loader: wishlistElement.querySelector("#swymcs-wishlist-loader"),
			container: wishlistElement.querySelector("#swymcs-wishlist-container"),
			listOptions: wishlistElement.querySelector("#swymcs-wishlist-list-options-container"),
			itemsContainer: wishlistElement.querySelector("#swymcs-wishlist-items-container"),
			emptyContainer: wishlistElement.querySelector("#swymcs-empty-wishlist-container"),
		};
	}

	async fetchList() {
		this.queryParams = this.swat.utils.getEncodedAsObject(window.location.search);
		this.sharedHkey = this.queryParams["hkey"] || this.queryParams["lid"];

		this.swat.fetchListCtx(
			{
				lid: this.sharedHkey,
			},
			(listContent) => {
				this.renderList(listContent);
			},
			(error) => {
				this.setAttribute("data-state", "error");
				console.log("Error when fetching wishlist", error);
			}
		);
	}

	async renderList(list) {
		this.elements.itemsContainer.innerHTML = "";
		if (list.length > 0) {
			await this.addProductDataToList(list);
			const wishlistedProducts = list.filter((p) => p.productData);

			wishlistedProducts.forEach((item) => {
				this.renderWishlistVariant(item);
			});
		}
		this.updateUIState(list);
	}

	async addProductDataToList(wishlist) {
		const productDataPromises = wishlist.map(async (listItem) => {
			const response = await fetch(`${listItem.du.split("?")[0]}.js`);
			listItem.productData = await response.json();
			return listItem;
		});
		await Promise.allSettled(productDataPromises);
		return wishlist;
	}

	async renderWishlistVariant(listItem) {
		const product = listItem.productData;
		const variant = product.variants.find((v) => String(v.id) === String(listItem.epi)) || product.variants[0];
		const wishlistItem = document.createElement("div");
		wishlistItem.classList.add("f-column", "card");
		wishlistItem.style.marginBottom = "0";
		wishlistItem.dataset.productId = product.id;
		wishlistItem.dataset.variantId = variant.id;

		const productImage = variant.featured_image
			? variant.featured_image.src
			: variant.image_id
				? product.images.find((img) => img.id == variant.image_id)?.src
				: product.featured_image || listItem.iu;

		let prefixLocaleUrl = window.Shopify?.locale === "en" ? "/en" : "";

		const productUrl = prefixLocaleUrl + product.url + (variant && variant.id ? `?variant=${variant.id}` : "");

		let customData = await this.getCustomDataProduct(product.handle);
		if (customData) {
			let materials = customData.materials || "";
			let attributes = customData.attributes || "";
			let templateSuffix = customData.templateSuffix || "";

			// Add custom data to the variant
			variant.customData = {
				materials: materials,
				attributes: attributes,
			};
			variant.templateSuffix = templateSuffix;
		}

		const preparedPrice = getFormattedPrice(variant.price, this.currency_symbol);
		const basePrice = getFormattedPrice(variant.compare_at_price, this.currency_symbol);
		const hasDiscount = variant.compare_at_price !== null && variant.parse !== variant.compare_at_price;

		wishlistItem.innerHTML = `
      <div class="product-card product-card-style-card h-full">
        <div class="product-card__wrapper h-full">
          <div class="product-card__image-wrapper">
            <a href="${productUrl}" aria-label="${product.title}" tabindex="-1">
              <motion-element data-motion="zoom-out-sm" class="block">
                <div class="media-wrapper  product-card__image wishlist-product-card__image--main" style="--aspect-ratio: 3/4;">
                  <img src="${productImage}" />
                </div>
              </motion-element>
            </a>
            ${
							this.settings.swym_wishlist_show_addtocart && variant.templateSuffix !== "prix-sur-demande"
								? `<form 
                id="quick-add-wishlist-${variant.id}"
                class="product-card__actions product-card__main-actions" 
                action="/cart/add" 
                method="post" 
                enctype="multipart/form-data"
                data-type="add-to-cart-form"
                is="product-form"
              >
                <input 
                  type="hidden" 
                  name="id" 
                  value="${variant.id}" 
                  class="product-variant-id"
                  ${!variant.available ? "disabled" : ""}
                >
                
                
                <!--Custom INPUT FOR MM Data-->
                <input
                  type="hidden"
                  name="properties[_attributes]"
                  value="${variant.attributes ?? ""}"
                >
                <input
                  type="hidden"
                  name="properties[_${this.translations.materials}]"
                  value="${variant.materials ?? ""}"
                >
                
                <button
                  id="quick-add-wishlist-${variant.id}-submit"
                  type="submit"
                  name="add"
                  ${!variant.available ? "disabled" : ""}
                  aria-label="Add to cart"
                  class="product-card__atc  btn btn--primary"
                   >
                  <!-- IF WE WANT A mobile button (round and bottom right, just add the class 'product-card__action-button' to the button and 'product-card__action-text' to the text span and uncomment span icon below -->
                
<!--                  <span class="product-card__atc-icon product-card__action-icon inline-flex md:hidden">-->
<!--                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.750553 0.0307932C0.544344 0.030793 0.347678 0.124022 0.211537 0.288781C0.0753947 0.45354 0.0130628 0.667203 0.0413512 0.87882L0.772665 5.70736H5.25017H7.25017H17.1068H19.1068H21.2276L21.9589 0.87882C21.9872 0.667203 21.9249 0.45354 21.7887 0.288781C21.6526 0.124022 21.4559 0.030793 21.2497 0.0307932H0.750553ZM19.1068 7.70736H21.1274L21.9582 20.0769C21.9582 20.0771 21.9583 20.0773 21.9583 20.0775C21.971 20.1853 21.9586 20.2943 21.9221 20.3964C21.8856 20.4986 21.8259 20.5912 21.747 20.6676C21.668 20.744 21.5718 20.8021 21.4649 20.8372C21.358 20.8722 21.2433 20.8832 21.1308 20.8696C21.1306 20.8695 21.1303 20.8695 21.1301 20.8695L13.6025 19.8689C13.5985 19.8683 13.5944 19.8678 13.5904 19.8673L5.35993 18.7694C5.35589 18.7688 5.35184 18.7682 5.3478 18.7677L0.841841 18.0774C0.839799 18.077 0.837754 18.0766 0.835708 18.0763C0.723235 18.0627 0.616603 18.0249 0.523731 17.9659C0.430859 17.9069 0.354472 17.8284 0.300401 17.7366C0.24633 17.6448 0.216215 17.5421 0.212424 17.437C0.208633 17.3319 0.231269 17.2273 0.278296 17.1319C0.278785 17.1309 0.279274 17.1299 0.279766 17.1289L1.77266 13.9639L1.77246 13.9639L3.27286 10.7857C3.27306 10.7854 3.27325 10.7851 3.27345 10.7847L4.77446 7.70736H6.74996H8.25016H17.1068H19.1068ZM7.25017 9.70736V15.7073H10.2502V9.70736H7.25017ZM12.2502 9.70736V15.7073H15.2502V9.70736H12.2502Z" fill="currentColor"/>-->
<!--                    </svg>-->
<!--                  </span>-->
                  <span class="product-card__atc-text">
                    ${variant.available ? FoxTheme.variantStrings.addToCart : FoxTheme.variantStrings.soldOut}
                  </span>
                  <div class="loading__spinner">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
              </form>`
								: ""
						}
          </div>
          <div class="product-card__info text-left">
            <h3 class="product-card__title text-pcard-title">
              <a class="reversed-link" href="${productUrl}">${product.title.toUpperCase()}</a>
            </h3>
            ${
							this.settings.swym_wishlist_show_price && variant.templateSuffix !== "prix-sur-demande"
								? hasDiscount
									? `<div class="wishlist__discount-price-container wishlist__size">
									<span class="wishlist__discount-price-initial"><s>${basePrice}</s></span>
									<span>${preparedPrice}</span>
									</div>`
									: `<div class="product__price wishlist__size">
									<span class="price product-card__price">
									<span class="price-item price-item--regular">
									${preparedPrice}
									</span>
									</span>
									</div>`
								: `<div class="product__price wishlist__size">
								<span class="price product-card__price">
								<span class="price-item price-item--regular">${FoxTheme.variantStrings.priceOnDemand}</span>
								</span>
								</div>`
						}
			<div class="product-card__variant-title wishlist__variant">
				${variant.title && variant.title !== "Default Title" ? variant.title : ""}
			</div>
          </div>
        </div>
      </div>
    `;

		this.elements.itemsContainer.appendChild(wishlistItem);

		//Add custom data attributes to the input element
		const customDataInput = wishlistItem.querySelector('input[name="properties[_attributes]"]');
		if (customDataInput && variant.customData && variant.customData.attributes) {
			customDataInput.value = JSON.stringify(variant.customData.attributes);
		}

		const materialsInput = wishlistItem.querySelector('input[name="properties[_' + this.translations.materials + ']"]');
		if (materialsInput && variant.customData && variant.customData.materials) {
			materialsInput.value = variant.customData.materials;
		}

		// Add to cart event
		const form = wishlistItem.querySelector(`#quick-add-wishlist-${variant.id}`);
		if (form) {
			form.addEventListener("submit", function (event) {
				event.preventDefault();
				const variantId = form.querySelector('input[name="id"]').value;
				const submitButton = form.querySelector(`#quick-add-wishlist-${variant.id}-submit`);
				const loadingSpinner = submitButton.querySelector(".loading__spinner");
				const buttonText = submitButton.querySelector(".product-card__action-text");
				loadingSpinner.classList.remove("hidden");
				addToCart(variantId, buttonText, loadingSpinner);
			});
		}

		/**
		 *
		 * @param {number} price
		 * @param {string} currency_symbol
		 */
		function getFormattedPrice(price, currency_symbol) {
			let preparedPrice = price;

			if (variant.price) {
				preparedPrice = (variant.price / 100).toFixed(2);
			} else {
				preparedPrice = (product.price / 100).toFixed(2);
			}
			//remove decimal it's not needed for the price
			preparedPrice = preparedPrice.replace(/\.00$/, "");

			if (currency_symbol === "€") {
				//Collé à droite
				preparedPrice = `${preparedPrice}${currency_symbol}`;
			} else if (currency_symbol === "CHF") {
				//à gauche avec espace
				preparedPrice = `${currency_symbol} ${preparedPrice}`;
			} else {
				//Collé à gauche
				preparedPrice = `${currency_symbol}${preparedPrice}`;
			}

			return preparedPrice;
		}

		function addToCart(variantId, buttonText, loadingSpinner) {
			if (loadingSpinner) loadingSpinner.classList.remove("hidden");
			fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify({
					items: [
						{
							id: variantId,
							quantity: 1,
						},
					],
				}),
			})
				.then((response) => {
					if (!response.ok) throw new Error("Network response was not ok");
					return response.json();
				})
				.then((data) => {
					if (data.items) {
						this.swat.ui.showSuccessNotification({
							message: `<strong>${data.items[0].product_title}</strong> has been added to cart!`,
						});
						if (buttonText) {
							buttonText.textContent = this.settings.swym_wishlist_item_cta_addedtocart || "Added to cart";
							setTimeout(() => (buttonText.textContent = this.settings.swym_wishlist_item_cta_addtocart || "Add to cart"), 2000);
						}
						// Let the theme handle cart opening automatically
						// The cart:refresh event is likely triggered by the theme in response to the /cart/add.js request
					} else {
						this.swat.ui.showErrorNotification({
							message: data.description || "Error adding product to cart",
						});
					}
				})
				.catch((error) => {
					console.error("Add to cart error:", error);
					this.swat.ui.showErrorNotification({ message: "Error adding product to cart" });
				})
				.finally(() => {
					if (loadingSpinner) loadingSpinner.classList.add("hidden");
				});
		}
	}

	updateUIState(wishlist) {
		if (wishlist.length > 0) {
			this.elements.container.classList.remove("swymcs-hide-container");
			this.elements.emptyContainer.classList.add("swymcs-hide-container");
		} else {
			this.elements.emptyContainer.classList.remove("swymcs-hide-container");
			this.elements.container.classList.add("swymcs-hide-container");
		}
		this.setAttribute("data-state", "done");
	}

	async getCustomDataProduct(productHandle) {
		let section_name = "api-gtm-product-attributes";
		let url = `/products/${productHandle}?section_id=` + section_name;

		return await fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");

				if (sectionInnerHTML) {
					const jsonElement = sectionInnerHTML.querySelector("#product-attributes-json");
					if (jsonElement) {
						try {
							let jsonText = jsonElement.textContent.trim();

							let jsonData = JSON.parse(JSON.parse(jsonText));
							jsonData.item_list_name = "wishlist";

							let materials = jsonData["materials"] || "";
							let templateSuffix = jsonData["template_suffix"] || "";

							//remove the materials key from jsonData
							delete jsonData["materials"];
							delete jsonData["template_suffix"];

							return {
								materials: materials,
								attributes: jsonData,
								templateSuffix: templateSuffix,
							};
						} catch (error) {
							console.error("Error parsing JSON:", error);
							return null;
						}
					} else {
						return null;
					}
				} else {
					return null;
				}
			});
	}
}
customElements.define("shared-wishlist", SharedWishlist);
